export default __webpack_public_path__ + "static/Tele_Lense_12mm_IRcut-6d4ec9a217b4966a1cbdf2af8cc1b096.webp";